import { useSelectedLanguageName } from '@/hooks/useSelectedLanguageName'
import { AnswerType } from '@app-studio-web/ui/types'
import QuizChoicePage from './QuizChoicePage'

const answers: AnswerType[] = [
  {
    emoji: '✈️',
    title: 'pages.quizOnboarding.motivation.answer1',
    value: 'travel',
  },
  {
    emoji: '💼',
    title: 'pages.quizOnboarding.motivation.answer2',
    value: 'job',
  },
  {
    emoji: '👨‍👩‍👧',
    title: 'pages.quizOnboarding.motivation.answer3',
    value: 'family',
  },
  {
    emoji: '💪',
    title: 'pages.quizOnboarding.motivation.answer4',
    value: 'confidence',
  },
  {
    emoji: '🧠',
    title: 'pages.quizOnboarding.motivation.answer5',
    value: 'brain',
  },
  {
    emoji: '🎬',
    title: 'pages.quizOnboarding.motivation.answer6',
    value: 'culture',
  },
]

export default function MotivationPage() {
  const language = useSelectedLanguageName()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const selected = event.currentTarget.value as string
    if (selected) localStorage.setItem('quizMotivation', selected)
  }

  return (
    <QuizChoicePage
      answers={answers}
      onSubmit={handleSubmit}
      title="pages.quizOnboarding.motivation.title"
      translationInterpolation={{ language }}
    />
  )
}
